// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"0b287df3","663":"9fd85062"}[chunkId] + ".chunk.js";
};